import { createRules } from "@hilma/forms";

export const loginCodeRules = createRules({
  code: {
    length: 6,
    required: true,
  },
});
